const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_secure-family-files-1/artifacts/6mo1nx9r_BeParentAppLogo_dark.png";

// Icon-only crop of the top portion of the square lockup.
// Uses background-image with sizing/positioning tuned to the artwork.
export function LogoMark({ size = 36, className = "" }) {
  return (
    <span
      className={`relative inline-block rounded-2xl border border-[#00FAF8]/25 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: "#0F172A",
        backgroundImage: `url(${LOGO_URL})`,
        backgroundSize: "200% auto",
        backgroundPosition: "50% 20%",
        backgroundRepeat: "no-repeat",
        boxShadow: "0 0 20px -6px rgba(0,250,248,0.45)",
      }}
      role="img"
      aria-label="BeParent"
    />
  );
}

// Full lockup (icon + wordmark + tagline).
export function LogoFull({ className = "", width = 320 }) {
  return (
    <img
      src={LOGO_URL}
      alt="BeParent — Eltern sein. Eltern bleiben."
      draggable={false}
      className={`select-none pointer-events-none ${className}`}
      style={{ width, height: "auto" }}
    />
  );
}

export { LOGO_URL };
